import vSelect from "vue-select";

function firstColorMap(...candidates) {
	for (const candidate of candidates) {
		if (candidate && typeof candidate === 'object' && Object.keys(candidate).length) {
			return candidate;
		}
	}
	return {};
}

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
		colors: {
			type: Object,
			required: false,
			default: () => ({}),
		}
	},

	components: {
		"v-select": vSelect,
	},

	computed: {
		statusColors() {
			return firstColorMap(
				this.colors,
				this.context?.colors,
				this.context?.node?.props?.colors,
				this.context?.attrs?.colors,
			);
		},
		rawOptions() {
			const options = this.context?.attrs?.options
				|| this.context?.node?.props?.options
				|| this.context?.options
				|| [];
			return Array.isArray(options) ? options : [];
		},
		selectOptions() {
			return this.rawOptions.map((item) => ({
				...item,
				label: item.label || item.title,
				value: item.value || item.uuid || item.machineName,
				machineName: item.machineName,
			}));
		},
		selectedOptions() {
			const values = Array.isArray(this.context?._value) ? this.context._value : [];
			return this.selectOptions.filter((opt) => values.includes(opt.value) || values.includes(opt.uuid) || values.includes(opt.id));
		},
	},

	methods: {
		handleInput(value) {
			if (this.context.node && typeof this.context.node.input === 'function') {
				this.context.node.input(value);
			} else if (this.context.handlers && typeof this.context.handlers.input === 'function') {
				this.context.handlers.input(value);
			}
		},
		onClose() {
			if (this.context.handlers?.blur) {
				this.context.handlers.blur();
			} else if (this.context.blurHandler) {
				this.context.blurHandler();
			}
		},

		onOpen() {},

		colorFor(option = {}) {
			const colors = this.statusColors;
			const raw = this.selectOptions.find((item) => (
				item === option
				|| item.value === option.value
				|| item.uuid === option.value
				|| item.id === option.value
				|| item.label === option.label
				|| item.title === option.label
			)) || option;

			const keys = [
				raw.machineName,
				option.machineName,
				raw.value,
				raw.uuid,
				raw.id,
				option.value,
			].filter(Boolean);

			if (raw.color || option.color) {
				return raw.color || option.color;
			}

			for (const key of keys) {
				if (colors[key]) return colors[key];
			}

			return '';
		},

		onOptionClick(option) {
			const current = Array.isArray(this.context._value) ? [...this.context._value] : [];
			const keys = [option.value, option.uuid, option.id].filter(Boolean);
			this.handleInput(current.filter((value) => !keys.includes(value)));
		}
	},
};
